import IMask from 'imask';

var phoneMask = IMask.createMask({
  mask: '+{7} (000) 000-0000',
  // lazy: false,
});

export const resetPhoneFormat = (value) => {
  var mask = IMask.createMask({
    mask: '+{7} (000) 000-0000',
  });

  mask.value = value;

  return mask.unmaskedValue;
};

export const setPhoneFormat = (value) => {
  if (!value) {
    return '+7 ';
  } else
    return phoneMask.resolve(resetPhoneFormat(value).replace(/^.{1}[8]/, '('));
};

export const checkPhoneFilling = (value) => {
  return value.replace(/\D/g, '').length === 11;
};

// Address autofill

const URL =
  'https://geocode-maps.yandex.ru/1.x/?apikey=6ac4f4c1-94f6-4433-a1a4-72fd0656a4d1&format=json&lang=ru_RU&geocode=';

export async function getAddresResponse(value) {
  let result = [];

  const response = await fetch(
    URL + encodeURIComponent('россия' + '+' + value)
  );

  const data = await response.json();

  data.response.GeoObjectCollection.featureMember.forEach((item) => {
    result.push({
      point: item.GeoObject.Point.pos,
      description:
        item.GeoObject.metaDataProperty.GeocoderMetaData.Address.formatted,
    });
  });

  return result;
}
const url =
  'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address';
//const url = 'https://cleaner.dadata.ru/api/v1/clean/address';
const token = 'f9ba47f215d1d12109471183635555b9d12bf8c4';
const secret = 'd5b5f38256b5c69e13aa02b2f5372abf0b745bd9';

export async function addressRequest(query) {
  let response = null;
  let result = [];
  const options = {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: 'Token ' + token,
    },
    body: JSON.stringify({ query: query, count: 5 }),
  };
  try {
    response = await fetch(url, options);
  } catch (err) {
    console.log('addressRequest response error', err);
  }

  const data = await response.json();

  result = data.suggestions.map((item) => {
    return {
      point: [item.data.geo_lat, item.data.geo_lon],
      description: item.value,
    };
  });

  return result;
}



// WEBPACK FOOTER //
// ./src/js/inputMasks.js